import React from 'react';
import Select from 'react-select';
import {FormControl, FormLabel, Text, CircularProgress, Box} from '@chakra-ui/react';
import {DocumentIcon} from "@heroicons/react/outline";

const CustomOption = ({innerProps, data, isFocused}: any) => (
  <Box
    {...innerProps}
    mx={2}
    my={2}
    p={2}
    display={"flex"}
    borderRadius="md"
    alignItems={"center"}
    borderWidth="1px"
    borderColor={isFocused ? 'blue.300' : 'gray.300'}
    backgroundColor={isFocused ? 'blue.50' : 'white'}
    cursor={"default"}
  >
    <Box mr={2} h={4} w={4}><DocumentIcon/></Box>
    {data.label.length > 50 ? `${data.label.substring(0, 50)}...` : data.label}
  </Box>
);

const ParentPageComponent = ({formik, isLoading, pages}: any) => {
  let bestOptions: any[] = pages
    ?.filter((d: any) => {
      return d?.parentType != 'database_id'
    })

  if (bestOptions?.length == 0) {
    bestOptions = pages
  }

  const options = bestOptions?.map((d) => ({
    value: d.id,
    label: d.title,
  }));

  return (
    <FormControl>
      <FormLabel>Parent page</FormLabel>
      <Text fontSize={"sm"} mb={2} color={"gray.500"}>
        Selected page will be used as parent for the database. You can move page later and can create database manually and configure it with NotionSender.
        <br/>
        NotionSender must have access to at least one page that can be used as parent.
        <br/>
        Pages are sorted by edit date, edit desired page if you do not see it in the list.

      </Text>
      {isLoading ? (
        <CircularProgress size={8} isIndeterminate color='blue.500'/>
      ) : (
        <Select
          name="databaseParent"
          components={{Option: CustomOption}}
          onChange={(option) => formik.setFieldValue('databaseParent', option?.value)}
          value={options?.find(option => option?.value === formik?.values?.databaseParent)}
          options={options}
          placeholder="Select parent page for database"
          isSearchable={false}
        />
      )}
    </FormControl>
  );
};

export default ParentPageComponent;
